import React from "react";
import Input from "./Input";
import Input_libas from "./Input_libas";
import Input_libas_extendNote from "./Input_libas_extendNote";
import Input_customer_emb from "./Input_customer_emb";
import Textarea from "./Textarea";
import Textarea_libas from "./Textarea_libas";
import Select from "./Select";
import RadioButtons from "./RadioButtons";
import CheckboxGroup from "./CheckboxGroup";
import Checkbox from "./Checkbox";
import CheckBox_MeasurementSetting from "./CheckBox_MeasurementSetting";
import DatePicker from "./DatePicker";
import DatePicker2 from "./DatePicker2";
//import ChakraInput from './ChakraInput'

function FormikControl(props) {
  const { control, ...rest } = props;
  switch (control) {
    case "input_hidden":
      return <Input {...rest} />;
    case "input":
      return <Input {...rest} />;
    case "input_libas":
      return <Input_libas {...rest} />;
    case "Input_customer_emb":
      return <Input_customer_emb {...rest} />;
    case "textarea":
      return <Textarea {...rest} />;
    case "textarea_libas":
      return <Textarea_libas {...rest} />;
    case "Input_libas_extendNote":
      return <Input_libas_extendNote {...rest} />;
    case "select":
      return <Select {...rest} />;
    case "radio":
      return <RadioButtons {...rest} />;
    case "checkboxGroup":
      return <CheckboxGroup {...rest} />;
    case "checkbox":
      return <Checkbox {...rest} />;
    case "CheckBox_MeasurementSetting":
      return <CheckBox_MeasurementSetting {...rest} />;
    case "date":
      return <DatePicker {...rest} />;
    case "date2":
      return <DatePicker2 {...rest} />;

    // case 'chakraInput':
    //   return <ChakraInput {...rest} />
    default:
      return null;
  }
}

export default FormikControl;
